<script lang="ts">
    // import type_delivery from '../../../assets/delivery.svg';
    // import type_collect from '../../../assets/collect.svg';
    import ColorSymbol from '../../shared/ColorSymbol.svelte';

    export let type: 'delivery' | 'collection' | null = 'delivery';
    export let scale: number = 1;
    export let color: string = '#60b9e6';

    // let src: string;

    // $: {
    //     switch (type) {
    //         case 'collection':
    //             type = 'collection';
    //             src = type_collect;
    //             break;
    //         default:
    //             type = 'delivery';
    //             src = type_delivery;
    //     }
    // }
</script>

<ColorSymbol {color} iconStyle="" {type} {scale} />
<!--<img src="{src}" style="width: 15px; height: 15px;" alt="{$_('job_type_'+type)}" title="{$_('job_type_'+type)}"/>-->
